/* PRELOADER */
(function preloader () {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const el = document.getElementById('preloader');
  const counter = document.getElementById('prec');
  if (reduced || !el) {
    document.body.classList.remove('is-loading');
    document.body.classList.add('is-ready');
    if (el) el.classList.add('is-gone');
    return;
  }

  el.classList.add('is-progress');
  let n = 0;
  const duration = 600;
  const start = performance.now();

  function tick (now) {
    const t = Math.min(1, (now - start) / duration);
    const eased = 1 - Math.pow(1 - t, 3);
    n = Math.floor(eased * 100);
    counter.textContent = String(n).padStart(3, '0');
    if (t < 1) requestAnimationFrame(tick);
    else {
      counter.textContent = '100';
      setTimeout(() => {
        document.body.classList.remove('is-loading');
        document.body.classList.add('is-ready');
        setTimeout(() => el.classList.add('is-out'), 80);
        setTimeout(() => el.classList.add('is-gone'), 2000);
      }, 120);
    }
  }
  requestAnimationFrame(tick);
})();

/* CUSTOM CURSOR — readability-safe (no inversion, precise tracking, text-aware) */
(function cursor () {
  const isFine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!isFine) return;

  const root = document.documentElement;
  root.classList.add('has-cursor');

  const dot = document.getElementById('cursor-dot');
  const ring = document.getElementById('cursor-ring');
  if (!dot || !ring) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const DOT_LERP  = reduce ? 1 : 0.85;   // dot rides the true pointer -> precise targeting
  const RING_LERP = reduce ? 1 : 0.20;   // ring eases in gently, no heavy lag

  let mx = window.innerWidth / 2, my = window.innerHeight / 2;
  let dx = mx, dy = my, rx = mx, ry = my;

  window.addEventListener('mousemove', (e) => { mx = e.clientX; my = e.clientY; }, { passive: true });
  document.addEventListener('mousedown', () => root.classList.add('cursor--down'));
  document.addEventListener('mouseup',   () => root.classList.remove('cursor--down'));

  function raf () {
    dx += (mx - dx) * DOT_LERP;  dy += (my - dy) * DOT_LERP;
    rx += (mx - rx) * RING_LERP; ry += (my - ry) * RING_LERP;
    dot.style.transform  = `translate3d(${dx}px, ${dy}px, 0) translate(-50%, -50%)`;
    ring.style.transform = `translate3d(${rx}px, ${ry}px, 0) translate(-50%, -50%)`;
    requestAnimationFrame(raf);
  }
  raf();

  /* One delegated state machine: nearest interactive ancestor wins, so a link inside
     a paragraph shows the hover ring while plain copy shows a slim text I-beam. */
  const HOVER_SEL = 'a, button, [data-cursor], [role="button"], summary, label[for]';
  const TEXT_SEL  = 'p, h1, h2, h3, h4, h5, h6, li, blockquote, figcaption, em, strong, time, dd, dt, input[type="text"], input[type="email"], input[type="search"], textarea, .rte, [data-read]';
  let state = null;
  function setState (s) {
    if (s === state) return;
    if (state) root.classList.remove('cursor--' + state);
    if (s) root.classList.add('cursor--' + s);
    state = s;
  }
  document.addEventListener('mouseover', (e) => {
    const el = e.target;
    if (!el || !el.closest) { setState(null); return; }
    const hov = el.closest(HOVER_SEL);
    if (hov) { setState(hov.getAttribute('data-cursor') || 'hover'); return; }
    setState(el.closest(TEXT_SEL) ? 'text' : null);
  }, { passive: true });

  document.addEventListener('mouseleave', () => { dot.style.opacity = 0; ring.style.opacity = 0; });
  document.addEventListener('mouseenter', () => { dot.style.opacity = ''; ring.style.opacity = ''; });
})();

/* LENIS SMOOTH SCROLL */
let lenis;
(function smoothScroll () {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  function start () {
    if (lenis || typeof Lenis === 'undefined') return;
    lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      smoothTouch: false,
      wheelMultiplier: 1.0,
    });
    window.lenis = lenis;
    function raf (time) { lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
  }

  if (typeof Lenis !== 'undefined') { start(); return; }
  var s = document.createElement('script');
  s.src = 'https://cdn.jsdelivr.net/npm/@studio-freight/lenis@1.0.42/dist/lenis.min.js';
  s.async = true;
  s.onload = start;
  document.head.appendChild(s);
})();

/* SCROLL REVEALS */
(function reveals () {
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        const lines = entry.target.querySelectorAll('.split-line > span');
        lines.forEach((line, idx) => { line.style.transitionDelay = (idx * 120) + 'ms'; });
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  document.querySelectorAll('[data-reveal], [data-reveal-img]').forEach(el => io.observe(el));
})();

/* MAGNETIC BUTTONS */
(function magnetic () {
  const isFine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!isFine) return;

  document.querySelectorAll('.btn').forEach(btn => {
    let raf = null;
    let tx = 0, ty = 0, cx = 0, cy = 0;

    btn.addEventListener('mousemove', (e) => {
      const rect = btn.getBoundingClientRect();
      tx = (e.clientX - rect.left - rect.width / 2) * 0.22;
      ty = (e.clientY - rect.top - rect.height / 2) * 0.28;
      if (!raf) raf = requestAnimationFrame(loop);
    });
    btn.addEventListener('mouseleave', () => { tx = 0; ty = 0; });

    function loop () {
      cx += (tx - cx) * 0.18;
      cy += (ty - cy) * 0.18;
      btn.style.transform = `translate3d(${cx.toFixed(2)}px, ${cy.toFixed(2)}px, 0)`;
      if (Math.abs(cx - tx) > 0.1 || Math.abs(cy - ty) > 0.1) {
        raf = requestAnimationFrame(loop);
      } else {
        btn.style.transform = `translate3d(${tx.toFixed(2)}px, ${ty.toFixed(2)}px, 0)`;
        raf = null;
      }
    }
  });
})();

/* HERO SLIDER */
(function heroSlider () {
  const slides = document.querySelectorAll('.hero-slide');
  const dots = document.querySelectorAll('.hp-item');
  const fill = document.querySelector('.hero-progress-fill');
  const hero = document.getElementById('hero');
  if (!slides.length || !dots.length || !fill || !hero) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const DURATION = 7500;

  let activeIdx = 0;
  let lastTs = performance.now();
  let elapsed = 0;
  let paused = false;
  let pageHidden = false;
  let advanceTimer = null;
  let rafId = null;

  function goTo (i, manual) {
    if (i === activeIdx) return;
    slides[activeIdx].classList.remove('is-active');
    dots[activeIdx].classList.remove('is-active');
    activeIdx = i;
    slides[activeIdx].classList.add('is-active');
    dots[activeIdx].classList.add('is-active');
    elapsed = 0;
    lastTs = performance.now();
    if (manual) { restartTimer(); }
  }

  function next () { goTo((activeIdx + 1) % slides.length, false); }

  function clearTimer () {
    if (advanceTimer) { clearTimeout(advanceTimer); advanceTimer = null; }
  }
  function restartTimer () {
    clearTimer();
    if (!paused && !pageHidden && !reduced) {
      advanceTimer = setTimeout(() => { next(); restartTimer(); }, DURATION - elapsed);
    }
  }

  function tick (now) {
    if (!paused && !pageHidden && !reduced) {
      const dt = now - lastTs;
      elapsed = Math.min(DURATION, elapsed + dt);
      const pct = elapsed / DURATION;
      fill.style.transform = `scaleX(${pct.toFixed(4)})`;
    }
    lastTs = now;
    rafId = requestAnimationFrame(tick);
  }

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => goTo(i, true));
  });

  hero.addEventListener('mouseenter', () => {
    paused = true;
    clearTimer();
  });
  hero.addEventListener('mouseleave', () => {
    paused = false;
    lastTs = performance.now();
    restartTimer();
  });

  document.addEventListener('visibilitychange', () => {
    pageHidden = document.hidden;
    if (pageHidden) { clearTimer(); }
    else { lastTs = performance.now(); restartTimer(); }
  });

  if (!reduced) {
    rafId = requestAnimationFrame(tick);
    restartTimer();
  } else {
    fill.style.transform = 'scaleX(1)';
  }
})();

/* MOBILE DRAWER */
(function drawer () {
  const open = document.getElementById('navOpen');
  const close = document.getElementById('navClose');
  const dr = document.getElementById('menuDrawer');
  const backdrop = document.getElementById('menuBackdrop');
  if (!open || !close || !dr) return;

  function openDrawer () {
    dr.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (lenis) lenis.stop();
  }
  function shut () {
    dr.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lenis) lenis.start();
  }

  open.addEventListener('click', openDrawer);
  close.addEventListener('click', shut);
  if (backdrop) backdrop.addEventListener('click', shut);
  dr.querySelectorAll('a').forEach(a => a.addEventListener('click', shut));

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && dr.classList.contains('is-open')) shut();
  });
})();

/* SITE MOTION — brings the Studies-page polish (top scroll-progress bar, scroll
   reveals, hero parallax, card tilt/spotlight) to every other page. Studies and
   article pages already run studies.js, so they are skipped here to avoid duplicates. */
(function siteMotion () {
  try {
    if (document.querySelector('script[src*="studies.js"]')) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var FINE = window.matchMedia('(hover:hover) and (pointer:fine)').matches;

    var css = document.createElement('style');
    css.textContent =
      '.sx-prog{position:fixed;top:0;left:0;right:0;height:2px;z-index:200;pointer-events:none;background:transparent}' +
      '.sx-prog i{display:block;height:100%;width:0;background:linear-gradient(90deg,#f5f5f0,rgba(245,245,240,.35));box-shadow:0 0 12px rgba(245,245,240,.45)}' +
      '@media (scripting: enabled){.sfx-rv{opacity:0;transform:translateY(46px);transition:opacity .9s cubic-bezier(.16,1,.3,1),transform 1.05s cubic-bezier(.16,1,.3,1);will-change:opacity,transform}.sfx-rv.sfx-in{opacity:1;transform:none}}' +
      '.sfx-tilt{position:relative}.sfx-tilt::after{content:"";position:absolute;inset:0;z-index:3;pointer-events:none;opacity:0;transition:opacity .45s cubic-bezier(.16,1,.3,1);background:radial-gradient(240px circle at var(--mx,50%) var(--my,50%),rgba(245,245,240,.12),transparent 62%)}.sfx-tilt:hover::after{opacity:1}' +
      '@media (prefers-reduced-motion:reduce){.sfx-rv{opacity:1 !important;transform:none !important;transition:none}}';
    document.head.appendChild(css);

    if (!document.querySelector('.sx-prog')) {
      var pr = document.createElement('div'); pr.className = 'sx-prog'; pr.setAttribute('aria-hidden', 'true'); pr.innerHTML = '<i></i>';
      document.body.appendChild(pr);
    }
    var pbar = document.querySelector('.sx-prog > i');

    var pars = [].slice.call(document.querySelectorAll('[data-par], .pg-hero-bg'));
    function frame () {
      var h = document.documentElement, sc = h.scrollTop || window.pageYOffset || 0, mx = h.scrollHeight - h.clientHeight;
      if (pbar) pbar.style.width = (mx > 0 ? Math.min(100, sc / mx * 100) : 0) + '%';
      if (!reduced) { var vh = window.innerHeight; pars.forEach(function (el) { var r = el.getBoundingClientRect(); var f = parseFloat(el.getAttribute('data-par')) || 0.1; var c = r.top + r.height / 2 - vh / 2; el.style.transform = 'translate3d(0,' + (c * f).toFixed(1) + 'px,0) scale(1.16)'; }); }
    }
    var ticking = false;
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(function () { frame(); ticking = false; }); ticking = true; } }, { passive: true });
    window.addEventListener('resize', frame); frame();

    var noExistingReveal = document.querySelectorAll('[data-reveal], [data-reveal-img]').length === 0;
    var isCart = !!document.querySelector('.cart-main');
    if (!reduced && noExistingReveal && !isCart && 'IntersectionObserver' in window) {
      var main = document.querySelector('main') || document.body;
      var secs = [].slice.call(main.children).filter(function (el) { return el.tagName === 'SECTION'; });
      if (secs.length < 2) secs = [].slice.call(main.querySelectorAll('section'));
      var blocks = [];
      secs.forEach(function (sec, i) {
        if (i === 0) return;
        var node = sec, guard = 0;
        while (node && node.children.length === 1 && /^(DIV|SECTION)$/.test(node.children[0].tagName) && guard++ < 4) node = node.children[0];
        var kids = [].slice.call(node.children).filter(function (c) { return /^(DIV|H1|H2|H3|H4|P|A|UL|OL|FIGURE|BLOCKQUOTE)$/.test(c.tagName) && (c.textContent.trim() || c.querySelector('img')); });
        if (!kids.length) kids = [sec];
        kids.forEach(function (k) { blocks.push(k); });
      });
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('sfx-in'); io.unobserve(e.target); } }); }, { threshold: 0.1, rootMargin: '0px 0px -7% 0px' });
      blocks.forEach(function (el) {
        el.classList.add('sfx-rv');
        var p = el.parentNode;
        if (p && /grid|cards|gal|row|list/i.test(p.className)) { var sibs = [].slice.call(p.children).filter(function (c) { return c.classList.contains('sfx-rv'); }); var idx = sibs.indexOf(el); if (idx > 0) el.style.transitionDelay = ((idx % 3) * 0.07).toFixed(2) + 's'; }
        io.observe(el);
      });
      setTimeout(function () { blocks.forEach(function (el) { el.classList.add('sfx-in'); }); }, 4500);
    }

    if (FINE && !reduced) document.querySelectorAll('.pg-card, .pg-feature, .pg-nextdisc').forEach(function (c) {
      if (c.classList.contains('sfx-tilt')) return;
      c.classList.add('sfx-tilt');
      c.addEventListener('mousemove', function (e) { var r = c.getBoundingClientRect(); var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height; c.style.setProperty('--mx', (px * 100).toFixed(1) + '%'); c.style.setProperty('--my', (py * 100).toFixed(1) + '%'); c.style.transition = 'transform .14s cubic-bezier(.16,1,.3,1)'; c.style.transform = 'perspective(1000px) translateY(-5px) rotateX(' + ((0.5 - py) * 4).toFixed(2) + 'deg) rotateY(' + ((px - 0.5) * 4).toFixed(2) + 'deg)'; });
      c.addEventListener('mouseleave', function () { c.style.transition = ''; c.style.transform = ''; c.style.removeProperty('--mx'); c.style.removeProperty('--my'); });
    });
  } catch (e) {
    try { [].forEach.call(document.querySelectorAll('.sfx-rv'), function (el) { el.classList.add('sfx-in'); }); } catch (_) {}
  }
})();
document.documentElement.classList.add('vysn-js');
